/* eslint-disable import/no-anonymous-default-export */
import { AppLayout } from "./layout-blueprints";

// Pages
import Home from "./pages/Home";
import Employees from "./pages/Employees";
import Tags from "./pages/Tags";
import EmployeeAddForm from "./pages/Employees/EmployeeAddForm";
import Codes from "./pages/Codes";
import EmployeeEditForm from "./pages/Employees/EmployeeEditForm";
import Applicants from "./pages/Applicants";
import ApplicantAddEditForm from "./pages/Applicants/ApplicantAddEditForm";
import Courses from "./pages/Training/Courses";
import AddEditTrainingCourse from "./pages/Training/Courses/AddEditTrainingCourse";
import AddEditTrainingParticipant from "./pages/Training/Participants/AddEditTrainingParticipant";
import AddEditTrainingCertification from "./pages/Training/Certifications/AddEditTrainingCertification";
import Certifications from "./pages/Training/Certifications";
import Participants from "./pages/Training/Participants";
import Summary from "./pages/Training/Summary";
import {
  PATH_TRAINING_PARTICIPANTS,
  PATH_TRAINING_PARTICIPANTS_ADD,
  PATH_TRAINING_COURSES,
  PATH_PARTICIPANTS_ADD,
  PATH_TRAINING_COURSES_ADD,
  PATH_TRAINING_COURSES_EDIT_COURSE_ID,
  PATH_TRAINING_COURSES_EDIT_ID,
  PATH_TRAINING_CERTIFICATIONS,
  PATH_TRAINING_CERTIFICATIONS_ADD,
  PATH_TRAINING_CERTIFICATIONS_EDIT_ID,
  PATH_TRAINING_SUMMARY,
  PATH_APPLICANTS,
  PATH_APPLICANTS_ADD,
  PATH_APPLICANTS_EDIT_ID,
  PATH_EMPLOYEE,
  PATH_EMPLOYEE_ADD,
  PATH_EMPLOYEE_EDIT_ID,
  PATH_PARTICIPANTS_EDIT_ID,
  PATH_HOME,
  PATH_TAGS,
  PATH_CODE_SETTING,
  PATH_CODE_SETTING_SUBPAGE,
  PATH_TRAINING_MASS_UPDATE,
  PATH_CUSTOM_IDS,
  PATH_CUSTOM_IDS_SUBPAGE,
  PATH_SECURITY,
  SLUG_SECURITY_SUBPAGE,
} from "./utils/routeConstants";
import MassUpdate from "./pages/Training/MassUpdate";
import CustomIds from "./pages/CustomIds";
import Security from "./pages/Security/index.js";

export const defaultUrl = `${PATH_HOME}`;

export default [
  { url: PATH_HOME, component: Home, layout: AppLayout },
  { url: PATH_EMPLOYEE, component: Employees, layout: AppLayout },
  { url: PATH_EMPLOYEE_ADD, component: EmployeeAddForm, layout: AppLayout },
  {
    url: PATH_EMPLOYEE_EDIT_ID,
    component: EmployeeEditForm,
    layout: AppLayout,
  },
  { url: PATH_TAGS, component: Tags, layout: AppLayout },
  { url: PATH_CODE_SETTING, component: Codes, layout: AppLayout },
  { url: PATH_CODE_SETTING_SUBPAGE, component: Codes, layout: AppLayout },
  { url: PATH_APPLICANTS, component: Applicants, layout: AppLayout },
  {
    url: PATH_APPLICANTS_ADD,
    component: ApplicantAddEditForm,
    layout: AppLayout,
  },
  {
    url: PATH_APPLICANTS_EDIT_ID,
    component: ApplicantAddEditForm,
    layout: AppLayout,
  },
  { url: PATH_TRAINING_COURSES, component: Courses, layout: AppLayout },
  {
    url: PATH_TRAINING_COURSES_ADD,
    component: AddEditTrainingCourse,
    layout: AppLayout,
  },
  {
    url: PATH_TRAINING_COURSES_EDIT_ID,
    component: AddEditTrainingCourse,
    layout: AppLayout,
  },
  {
    url: PATH_TRAINING_PARTICIPANTS,
    component: Participants,
    layout: AppLayout,
  },
  {
    url: PATH_TRAINING_PARTICIPANTS_ADD,
    component: AddEditTrainingParticipant,
    layout: AppLayout,
  },
  {
    url: `${PATH_TRAINING_COURSES_EDIT_COURSE_ID}${PATH_PARTICIPANTS_ADD}`,
    component: AddEditTrainingParticipant,
    layout: AppLayout,
  },
  {
    url: `${PATH_TRAINING_COURSES_EDIT_COURSE_ID}${PATH_PARTICIPANTS_EDIT_ID}`,
    component: AddEditTrainingParticipant,
    layout: AppLayout,
  },
  {
    url: PATH_TRAINING_CERTIFICATIONS,
    component: Certifications,
    layout: AppLayout,
  },
  {
    url: PATH_TRAINING_CERTIFICATIONS_ADD,
    component: AddEditTrainingCertification,
    layout: AppLayout,
  },
  {
    url: PATH_TRAINING_CERTIFICATIONS_EDIT_ID,
    component: AddEditTrainingCertification,
    layout: AppLayout,
  },
  {
    url: PATH_TRAINING_MASS_UPDATE,
    component: MassUpdate,
    layout: AppLayout,
  },
  {
    url: PATH_TRAINING_SUMMARY,
    component: Summary,
    layout: AppLayout,
  },
  {
    url: PATH_CUSTOM_IDS,
    component: CustomIds,
    layout: AppLayout,
  },
  {
    url: PATH_CUSTOM_IDS_SUBPAGE,
    component: CustomIds,
    layout: AppLayout,
  },
  {
    url: PATH_SECURITY,
    component: Security,
    layout: AppLayout,
  },
  { url: SLUG_SECURITY_SUBPAGE, component: Security, layout: AppLayout },
];
